module.exports = __webpack_public_path__ + "wall-clock.96630a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/token_earning/wall-clock.png
// module id = 307
// module chunks = 0